import React, {Component} from 'react';
import isMobile from 'ismobilejs';

import Registry from '../../../registry';

import {addToHomeScreen, deferredPrompt} from '../../../homeScreen';
import './styles.scss';

import Button from '../UIKit/Button';

class GeneralOptions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mood: '',
            pm_enabled: null,
            mood_visible: null,
        }
    }

    componentDidMount() {
        const { currentUser } = this.props;
        let siteInterface = Registry.get('siteInterface');
        const isAnonymous = currentUser.isAnonymous();

        if (!isAnonymous) {
            siteInterface.getUserMoodText()
            .then(res => {
                this.setState({
                    mood: res.data.data.mood,
                    pm_enabled: +res.data.data.pm_enabled,
                    mood_visible: +res.data.data.mood_visible,
                });
            });
        }
    }

    sendData = () => {
        const siteInterface = Registry.get('siteInterface');
        siteInterface.setUserMood(this.state);
        this.props.onSuccess();
    };
    
    render() {
        const lang = Registry.get('locale');
        const {mood, pm_enabled, mood_visible} = this.state;

        const {currentUser} = this.props;
        const isAnonymous = currentUser.isAnonymous();
        const isUserFree = !currentUser.isAnonymous() && !currentUser.isXXL();

        const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
        const showAddButton = isChrome && !isMobile.apple.device && deferredPrompt && !window.matchMedia('(display-mode: standalone)').matches
        return (
            <div className='settings-tab GeneralOptions'>
                <div className="options">
                    <div className='change-status'>
                        <span className={`label  ${(isUserFree || isAnonymous) ? 'disabled' : ''}`}>
                            {lang.your_mood}
                        </span>
                        <textarea
                            placeholder={lang.placeholder}
                            value={currentUser.isXXL() ? mood : lang.you_must_be_xxl}
                            maxLength='250'
                            onChange={(event) => this.setState({mood: event.target.value})}
                            disabled={isUserFree || isAnonymous}
                        />
                    </div>

                    <div className='checkbox-type show-status'>
                        <input
                            name='closed'
                            type='checkbox'
                            id='input_show_mood'
                            checked={mood_visible && !isUserFree ? true : false}
                            onChange={(event) => this.setState({mood_visible: +event.target.checked})}
                            disabled={isUserFree || isAnonymous}
                        />
                        <label className={`label-new  ${(isUserFree || isAnonymous) ? 'disabled' : ''}`} htmlFor='input_show_mood'>{lang.show_your_mood}</label>
                    </div>

                    <div className='checkbox-type show-private-messages'>
                        <input
                            name='closed'
                            type='checkbox'
                            disabled={isAnonymous}
                            id='input_show_private_messages'
                            checked={pm_enabled ? true : false}
                            onChange={(event) => this.setState({pm_enabled: +event.target.checked})}
                        />
                        <label className={`label-new  ${isAnonymous ? 'disabled' : ''}`} htmlFor='input_show_private_messages'>{lang.private_messages}</label>
                    </div>
                </div>

                <div className='bottom'>
                    <Button text={lang.apply} default onClick={this.sendData} />
                    {showAddButton &&
                        <Button text={lang.addToHomescreen} onClick={addToHomeScreen} />
                    }
                    {!deferredPrompt && isChrome &&
                        <div className="removeInfo">
                            {lang.removeApp}
                            <a href="chrome://apps">chrome://apps</a>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default GeneralOptions;



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/GeneralOptions/index.js